var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import { Close } from '@material-ui/icons';
import Loader from '../../components/Loader';
import CircleIcon from '../../components/CircleIcon';
import ScaleSlider from '../../components/ScaleSlider';
import CtaButton from '../../components/CtaButton';
import ImageHelper from '../../core/helpers/image-helper';
import { cancelPhotoReposition } from './store/actions';
import { replaceCartItem } from '../Cart/store/actions';
import { updatePhoto } from '../Photo/store/actions';
import { updateCartItemEditor } from '../CartItemEditor/store/actions';
var mapStateToProps = function (state) { return ({
    selectedPhoto: state.cartItemEditor.selectedPhoto,
}); };
var mapDispatchToProps = {
    cancelPhotoReposition: cancelPhotoReposition,
    updatePhoto: updatePhoto,
    replaceCartItem: replaceCartItem,
    updateCartItemEditor: updateCartItemEditor,
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var PhotoEditor = /** @class */ (function (_super) {
    __extends(PhotoEditor, _super);
    function PhotoEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrapperRef = null;
        _this.imageRef = null;
        _this.imageWrapperRef = null;
        _this.overlayRef = null;
        _this.pointers = [];
        _this.latestScale = null;
        _this.isResizing = false;
        // positioning
        _this.isPositioning = false;
        _this.latestPositionX = null;
        _this.latestPositionY = null;
        _this.state = {
            wrapperWidth: null,
            wrapperHeight: null,
            image: {
                status: 'unloaded',
                rotate: 0,
                scale: 1,
                minimumScale: 1,
                maximumScale: 3,
                origWidth: 0,
                origHeight: 0,
                positionX: 0,
                positionY: 0,
                original: {
                    scale: 1,
                    rotate: 0,
                    positionX: 0,
                    positionY: 0,
                },
            },
            resizing: {
                started: false,
                scale: 1,
            },
            positioning: {
                started: false,
                originalPositionX: 0,
                originalPositionY: 0,
            },
        };
        return _this;
    }
    PhotoEditor.prototype.componentDidMount = function () {
        document.body.style.overflow = 'hidden';
    };
    PhotoEditor.prototype.componentWillUnmount = function () {
        document.body.style.overflow = 'visible';
    };
    PhotoEditor.prototype.render = function () {
        var _this = this;
        if (!this.props.selectedPhoto) {
            return;
        }
        return (React.createElement("div", { className: "c-photo-editor" },
            'loaded' !== this.state.image.status ? React.createElement(Loader, null) : null,
            this.renderQualityWarning(),
            React.createElement("div", { className: "c-photo-editor__header" },
                React.createElement("div", { className: "c-photo-editor__header__title" },
                    React.createElement("h1", null, this.props.t('order.photo_editor.title'))),
                React.createElement("div", { className: "c-photo-editor__header__close" },
                    React.createElement("a", { href: "#", onClick: function () { return _this.cancel(); } },
                        React.createElement(Close, { style: { width: 30, height: 30 } })))),
            React.createElement("div", { ref: function (ref) { return _this.setWrapperRef(ref); }, className: "c-photo-editor__content" }, this.renderPhoto()),
            React.createElement("div", { className: "c-photo-editor__bottom" },
                React.createElement("h2", { className: "h-margin--0 h-font-size--12 h-font-weight--700 h-color--white h-text--center h-text-transform--uppercase" }, this.props.t('order.photo_editor.rotate.title')),
                React.createElement("div", { className: "c-photo-editor__actions h-margin-top--10" },
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement(CircleIcon, { onClick: function () { return _this.rotate(-90); } },
                                React.createElement("i", { className: "icon-rotate-left" }))),
                        React.createElement("li", null,
                            React.createElement(CircleIcon, { onClick: function () { return _this.rotate(90); } },
                                React.createElement("i", { className: "icon-rotate-right" }))))),
                React.createElement("h2", { className: "h-margin--0 h-margin-top--20 h-font-size--12 h-font-weight--700 h-color--white h-text--center h-text-transform--uppercase" }, this.props.t('order.photo_editor.zoom.title')),
                React.createElement("div", { className: "c-photo-editor__zoom h-margin-top--10" },
                    React.createElement(ScaleSlider, { onChange: function (scale) { return _this.handleScaleChanged(scale); }, onFinished: function (scale) { return _this.handleScaleFinished(scale); }, value: this.state.image.scale, minValue: this.state.image.minimumScale, maxValue: this.state.image.maximumScale })),
                React.createElement("div", { className: "c-photo-editor__save h-margin-top--15" },
                    React.createElement(CtaButton, { icon: "checkmark", label: "order.photo_editor.save_button", modifier: ['white'], clickHandler: function () { return _this.save(); } })))));
    };
    PhotoEditor.prototype.renderQualityWarning = function () {
        var _a, _b;
        if (!this.props.selectedPhoto) {
            return null;
        }
        var origDpi = Math.floor((_a = this.props.selectedPhoto.getOriginalDpi(this.state.image.rotate)) !== null && _a !== void 0 ? _a : 0);
        if (origDpi < 150) {
            return (React.createElement("div", { className: "c-quality-alert" },
                React.createElement("h1", null, this.props.t('order.photo_editor.quality_alert.title')),
                React.createElement("p", null, this.props.t('order.photo_editor.quality_alert.message'))));
        }
        var dpi = Math.floor((_b = this.props.selectedPhoto.getDpi(this.state.image.scale, this.state.image.rotate)) !== null && _b !== void 0 ? _b : 0);
        if (dpi > 150) {
            return null;
        }
        return (React.createElement("div", { className: "c-quality-alert" },
            React.createElement("h1", null, this.props.t('order.photo_editor.quality_zoom_alert.title')),
            React.createElement("p", null, this.props.t('order.photo_editor.quality_zoom_alert.message'))));
    };
    PhotoEditor.prototype.renderPhoto = function () {
        var _this = this;
        if (!this.state.wrapperWidth || !this.state.wrapperHeight) {
            return null;
        }
        if (!this.props.selectedPhoto) {
            return null;
        }
        return (React.createElement("div", { style: { touchAction: 'none', width: '100%', height: '100%' } },
            React.createElement("h2", { className: "c-photo-editor__photo__title", style: this.getWindowTitleStyle() }, this.props.t('order.photo_editor.photo.title')),
            React.createElement("div", { className: "c-photo-editor__photo__overlay", ref: function (ref) { return _this.setOverlayRef(ref); }, style: this.getWindowStyle(), onPointerDown: function (event) { return _this.handlePointerDown(event); }, onPointerMove: function (event) { return _this.handlePointerMove(event); }, onPointerUp: function (event) { return _this.handlePointerUp(event); }, onPointerLeave: function (event) { return _this.handlePointerUp(event); }, onPointerCancel: function (event) { return _this.handlePointerUp(event); } }),
            React.createElement("div", { ref: function (ref) { return _this.setImageWrapperRef(ref); }, className: "c-photo-editor__photo__wrapper", style: this.getImageWrapperStyle() },
                React.createElement("img", { ref: function (ref) { return _this.setImageRef(ref); }, className: "c-photo-editor__photo", src: this.props.selectedPhoto.getUri(), alt: "", style: this.getImageStyle(), onLoad: function () { return _this.handleImageLoaded(); } }))));
    };
    PhotoEditor.prototype.setWrapperRef = function (ref) {
        if (this.wrapperRef) {
            return;
        }
        this.wrapperRef = ref;
        this.updateWrapperSizes();
    };
    PhotoEditor.prototype.setImageRef = function (ref) {
        if (this.imageRef) {
            return;
        }
        this.imageRef = ref;
    };
    PhotoEditor.prototype.setImageWrapperRef = function (ref) {
        if (this.imageWrapperRef) {
            return;
        }
        this.imageWrapperRef = ref;
    };
    PhotoEditor.prototype.setOverlayRef = function (ref) {
        if (this.overlayRef) {
            return;
        }
        this.overlayRef = ref;
    };
    PhotoEditor.prototype.updateWrapperSizes = function () {
        if (!this.wrapperRef) {
            return;
        }
        this.setState({
            wrapperWidth: this.wrapperRef.clientWidth,
            wrapperHeight: this.wrapperRef.clientHeight,
        });
    };
    PhotoEditor.prototype.handleScaleChanged = function (scale) {
        this.latestScale = scale - this.state.image.scale;
        this.rescaleImage();
    };
    PhotoEditor.prototype.handleScaleFinished = function (scale) {
        var _this = this;
        this.latestScale = scale - this.state.image.scale;
        window.setTimeout(function () {
            _this.saveAndClearLatestScale();
        }, 0);
    };
    PhotoEditor.prototype.handlePointerDown = function (event) {
        event.stopPropagation();
        this.pointers = __spreadArray(__spreadArray([], this.pointers), [
            {
                id: event.pointerId,
                originalClientX: event.clientX,
                originalClientY: event.clientY,
            },
        ]);
        if (this.pointers.length > 1) {
            this.stopPositioning();
            this.startResizing();
            return;
        }
        this.startPositioning();
    };
    PhotoEditor.prototype.handlePointerUp = function (event) {
        event.stopPropagation();
        this.stopPositioning();
        this.stopResizing();
        this.clearPointers();
    };
    PhotoEditor.prototype.handlePointerMove = function (event) {
        event.stopPropagation();
        this.resizeImage(event);
        this.positionImage(event);
    };
    PhotoEditor.prototype.positionImage = function (event) {
        if (!this.isPositioning) {
            return;
        }
        var pointer = this.pointers.find(function (item) { return item.id === event.pointerId; });
        if (!pointer) {
            return;
        }
        if (!this.overlayRef) {
            return;
        }
        var overlayPosition = this.overlayRef.getBoundingClientRect();
        var imageSize = this.getScaledImageSize();
        if (!imageSize) {
            return;
        }
        this.latestPositionX = event.clientX - pointer.originalClientX;
        this.latestPositionY = event.clientY - pointer.originalClientY;
        var isImageUpsideDown = this.isImageUpsideDown();
        var imageWidthToCheck = isImageUpsideDown ? imageSize.height : imageSize.width;
        var imageHeightToCheck = isImageUpsideDown ? imageSize.width : imageSize.height;
        var limitX = Math.floor((imageWidthToCheck - overlayPosition.width) / 2);
        var minusLimitX = limitX * -1;
        var limitY = Math.floor((imageHeightToCheck - overlayPosition.height) / 2);
        var minusLimitY = limitY * -1;
        var positionX = this.state.image.positionX + this.latestPositionX;
        var positionY = this.state.image.positionY + this.latestPositionY;
        if (positionX > limitX) {
            this.latestPositionX = Math.max(0, limitX - this.state.image.positionX);
        }
        if (positionX < minusLimitX) {
            this.latestPositionX = Math.min(0, minusLimitX - this.state.image.positionX);
        }
        if (positionY > limitY) {
            this.latestPositionY = Math.max(0, limitY - this.state.image.positionY);
        }
        if (positionY < minusLimitY) {
            this.latestPositionY = Math.min(0, minusLimitY - this.state.image.positionY);
        }
        if (!this.imageWrapperRef) {
            return;
        }
        this.imageWrapperRef.style.marginLeft = this.state.image.positionX + this.latestPositionX + "px";
        this.imageWrapperRef.style.marginTop = this.state.image.positionY + this.latestPositionY + "px";
    };
    PhotoEditor.prototype.resizeImage = function (event) {
        if (!this.isResizing) {
            return;
        }
        if (2 !== this.pointers.length) {
            return;
        }
        // only follow one pointer avoiding buggy behaviour (distance is jumping)
        if (event.pointerId !== this.pointers[0].id) {
            return;
        }
        var pointer = this.pointers.find(function (pointer) { return pointer.id !== event.pointerId; });
        if (!pointer) {
            return;
        }
        var originalDistance = Math.hypot(Math.abs(this.pointers[0].originalClientX - this.pointers[1].originalClientX), Math.abs(this.pointers[0].originalClientY - this.pointers[1].originalClientY));
        var currentDistance = Math.hypot(Math.abs(pointer.originalClientX - event.clientX), Math.abs(pointer.originalClientY - event.clientY));
        this.latestScale = (currentDistance - originalDistance) / 100;
        var scale = this.state.image.scale + this.latestScale;
        if (scale < this.state.image.minimumScale) {
            this.latestScale = (this.state.image.minimumScale - this.state.image.scale);
        }
        if (scale > this.state.image.maximumScale) {
            this.latestScale = (this.state.image.maximumScale - this.state.image.scale);
        }
        this.rescaleImage();
    };
    PhotoEditor.prototype.rescaleImage = function () {
        var imageSize = this.getImageSize();
        if (!this.imageRef || !this.latestScale || !imageSize) {
            return;
        }
        var width = imageSize.width * (this.state.image.scale + this.latestScale);
        var height = imageSize.height * (this.state.image.scale + this.latestScale);
        this.imageRef.style.width = width + "px";
        this.imageRef.style.height = height + "px";
        this.imageRef.style.marginLeft = width / 2 * -1 + "px";
        this.imageRef.style.marginTop = height / 2 * -1 + "px";
    };
    PhotoEditor.prototype.clearPointers = function () {
        this.pointers = [];
    };
    PhotoEditor.prototype.startPositioning = function () {
        if (this.isPositioning) {
            return;
        }
        this.isPositioning = true;
    };
    PhotoEditor.prototype.stopPositioning = function () {
        if (!this.isPositioning) {
            return;
        }
        this.isPositioning = false;
        if (null === this.latestPositionX || null === this.latestPositionY) {
            return;
        }
        this.setState({
            image: __assign(__assign({}, this.state.image), { positionX: this.state.image.positionX + this.latestPositionX, positionY: this.state.image.positionY + this.latestPositionY }),
        });
        this.latestPositionX = null;
        this.latestPositionY = null;
    };
    PhotoEditor.prototype.startResizing = function () {
        if (this.isResizing) {
            return;
        }
        this.isResizing = true;
    };
    PhotoEditor.prototype.stopResizing = function () {
        if (!this.isResizing) {
            return;
        }
        this.isResizing = false;
        this.saveAndClearLatestScale();
    };
    PhotoEditor.prototype.saveAndClearLatestScale = function () {
        if (!this.latestScale) {
            return;
        }
        this.setState({
            image: __assign(__assign({}, this.state.image), { scale: (this.state.image.scale + this.latestScale), positionX: 0, positionY: 0 }),
        });
        this.latestScale = null;
    };
    PhotoEditor.prototype.getWindowTitleStyle = function () {
        var windowSize = this.getWindowSize();
        if (!windowSize) {
            return {};
        }
        return {
            touchAction: 'none',
            width: windowSize.width,
            marginLeft: windowSize.width / 2 * -1,
            marginTop: windowSize.height / 2 * -1 - 30,
        };
    };
    PhotoEditor.prototype.getWindowStyle = function () {
        var windowSize = this.getWindowSize();
        if (!windowSize) {
            return {};
        }
        return {
            touchAction: 'none',
            width: windowSize.width,
            height: windowSize.height,
            marginLeft: windowSize.width / 2 * -1,
            marginTop: windowSize.height / 2 * -1,
        };
    };
    PhotoEditor.prototype.getImageStyle = function () {
        var imageSize = this.getScaledImageSize();
        if (!imageSize) {
            return {};
        }
        return {
            touchAction: 'none',
            width: imageSize.width,
            height: imageSize.height,
            marginLeft: imageSize.width / 2 * -1,
            marginTop: imageSize.height / 2 * -1,
            transform: "rotate(" + this.state.image.rotate + "deg",
        };
    };
    PhotoEditor.prototype.getImageWrapperStyle = function () {
        return {
            touchAction: 'none',
            marginLeft: this.state.image.positionX,
            marginTop: this.state.image.positionY,
        };
    };
    PhotoEditor.prototype.getImageSize = function () {
        if (!this.imageRef) {
            return null;
        }
        var imageRatio = this.getImageRatio();
        if (!imageRatio) {
            return null;
        }
        var width = this.imageRef.naturalWidth * imageRatio;
        var height = this.imageRef.naturalHeight * imageRatio;
        return {
            width: width,
            height: height,
        };
    };
    PhotoEditor.prototype.getScaledImageSize = function () {
        var imageSize = this.getImageSize();
        if (!imageSize) {
            return null;
        }
        var width = imageSize.width * this.state.image.scale;
        var height = imageSize.height * this.state.image.scale;
        return {
            width: width,
            height: height,
        };
    };
    PhotoEditor.prototype.getWindowSize = function () {
        if (!this.props.selectedPhoto) {
            return null;
        }
        var maxSizes = this.getWindowMaxSizes();
        if (!maxSizes) {
            return null;
        }
        var innerSize = this.props.selectedPhoto.getInnerSize(maxSizes.maxWidth, maxSizes.maxHeight);
        if (!innerSize) {
            return null;
        }
        return innerSize;
    };
    PhotoEditor.prototype.getWindowMaxSizes = function () {
        var wrapperWidth = this.state.wrapperWidth;
        var wrapperHeight = this.state.wrapperHeight;
        if (!wrapperWidth || !wrapperHeight) {
            return null;
        }
        var maxWidth = Math.ceil(wrapperWidth * .8);
        var maxHeight = Math.ceil(wrapperHeight * .8);
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight,
        };
    };
    PhotoEditor.prototype.handleImageLoaded = function () {
        if (!this.imageRef) {
            return;
        }
        if (!this.props.selectedPhoto) {
            return;
        }
        var ratio = this.getImageRatio(this.props.selectedPhoto.rotate);
        if (!ratio) {
            return;
        }
        this.setState({
            image: __assign(__assign({}, this.state.image), { status: 'loaded', minimumScale: this.props.selectedPhoto.product_item.minimum_scale, scale: this.props.selectedPhoto.scale, rotate: this.props.selectedPhoto.rotate, positionX: this.props.selectedPhoto.position_x * ratio, positionY: this.props.selectedPhoto.position_y * ratio, original: __assign(__assign({}, this.state.image.original), { scale: this.props.selectedPhoto.scale, rotate: this.props.selectedPhoto.rotate, positionX: this.props.selectedPhoto.position_x * ratio, positionY: this.props.selectedPhoto.position_y * ratio }) }),
        });
    };
    PhotoEditor.prototype.getImageRatio = function (rotate) {
        if (rotate === void 0) { rotate = null; }
        if (!this.imageRef) {
            return null;
        }
        var windowSize = this.getWindowSize();
        if (!windowSize) {
            return null;
        }
        return ImageHelper.getRatioByWindowSize(this.imageRef.naturalWidth, this.imageRef.naturalHeight, windowSize.width, windowSize.height, rotate !== null && rotate !== void 0 ? rotate : this.state.image.rotate);
        // console.log(
        //     this.imageRef.naturalHeight,
        //     (this.props.selectedPhoto?.original_photo.height * ratio - windowSize.width),
        //     (this.props.selectedPhoto?.original_photo.height * ratio - windowSize.width) / ratio,
        //     ratio
        // )
    };
    PhotoEditor.prototype.rotate = function (degree) {
        if (!this.imageRef || !this.props.selectedPhoto) {
            return;
        }
        var rotateDegree = this.state.image.rotate + degree;
        if (rotateDegree < 0) {
            rotateDegree = 360 + rotateDegree;
        }
        if (Math.abs(rotateDegree) >= 360) {
            rotateDegree = 0;
        }
        this.setState({
            image: __assign(__assign({}, this.state.image), { minimumScale: this.props.selectedPhoto.product_item.minimum_scale, scale: 1, rotate: rotateDegree, positionX: 0, positionY: 0 }),
        });
    };
    PhotoEditor.prototype.isImageUpsideDown = function (degree) {
        return [90, 270].includes(Math.abs(degree !== null && degree !== void 0 ? degree : this.state.image.rotate));
    };
    PhotoEditor.prototype.cancel = function () {
        this.reset();
        this.props.cancelPhotoReposition();
    };
    PhotoEditor.prototype.reset = function () {
        this.setState(__assign(__assign({}, this.state), { image: __assign(__assign({}, this.state.image), this.state.image.original) }));
    };
    PhotoEditor.prototype.save = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var ratio, payload, response, selectedPhoto;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.props.selectedPhoto) {
                            return [2 /*return*/];
                        }
                        ratio = this.getImageRatio();
                        if (!ratio) {
                            return [2 /*return*/];
                        }
                        payload = {
                            scale: this.state.image.scale,
                            position_x: this.state.image.positionX / ratio,
                            position_y: this.state.image.positionY / ratio,
                            rotate: this.state.image.rotate,
                        };
                        return [4 /*yield*/, this.props.updatePhoto(this.props.selectedPhoto, payload)];
                    case 1:
                        response = _b.sent();
                        if (!response) {
                            return [2 /*return*/];
                        }
                        selectedPhoto = (_a = response.photos.find(function (item) { var _a; return item.id === ((_a = _this.props.selectedPhoto) === null || _a === void 0 ? void 0 : _a.id); })) !== null && _a !== void 0 ? _a : null;
                        this.props.replaceCartItem(response);
                        this.props.updateCartItemEditor({
                            productItems: __spreadArray([], response.product.items),
                            photos: __spreadArray([], response.photos),
                            selectedPhoto: selectedPhoto,
                        });
                        this.props.cancelPhotoReposition();
                        return [2 /*return*/];
                }
            });
        });
    };
    return PhotoEditor;
}(React.Component));
export default connector(withRouter(withTranslation()(PhotoEditor)));
